import React from 'react';
import { Plus } from 'lucide-react';

const NotificationBanner = ({ notification, onClose }) => {
  if (!notification) return null;

  return (
    <div className={`fixed top-4 right-4 z-50 p-4 rounded-lg border shadow-lg max-w-sm ${
      notification.type === 'error' 
        ? 'bg-red-900 border-red-700 text-red-100' 
        : 'bg-green-900 border-green-700 text-green-100'
    }`}>
      <div className="flex items-start space-x-3">
        <div className="flex-1 text-sm">{notification.message}</div>
        <button onClick={onClose} className="text-current hover:opacity-70">
          <Plus className="w-4 h-4 rotate-45" />
        </button>
      </div>
    </div>
  );
};

export default NotificationBanner;